import DOMPurify from 'dompurify';

export const previewMessage = 'Preview only. Preview controls show the next step without sending form data or recording a Hum campaign impression or conversion. Redirects open the configured URL; that destination may still record a visit or UTM tracking.';

// Form controls are allowed only in the main preview. Neither preview markup
// nor success content may execute code or attach conversion tracking.
export function sanitizeCampaignHtml(html, previewForm = false) {
   return DOMPurify.sanitize(typeof html === 'string' ? html : '', {
      USE_PROFILES: {html: true},
      FORBID_TAGS: previewForm
         ? ['script', 'style', 'iframe', 'object', 'embed', 'form']
         : ['script', 'style', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'select', 'textarea'],
      FORBID_ATTR: ['data-conversion-target', 'autofocus', 'formaction', 'action', 'srcdoc', 'form', 'for'],
   });
}

export function successContent(form) {
   const html = sanitizeCampaignHtml(form?.success_message_html);
   const content = document.createElement('div');
   content.innerHTML = html;
   return content.textContent.trim() || content.querySelector('img') ? html : '';
}

export function resolveRedirect(campaign, targetUrl) {
   return targetUrl || campaign?.form_data?.submit_link?.trim() || campaign?.goal_url || '';
}

export function successOptions(form) {
   const html = successContent(form);
   return {
      html,
      text: '',
      title: html ? '' : 'Thank You!',
      icon: html ? undefined : 'success',
      footer: '',
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: true,
      preConfirm: undefined,
      timer: undefined,
   };
}

const guardedPopups = new WeakSet();

export function preventPreviewSubmission(popup) {
   if (guardedPopups.has(popup)) return;
   guardedPopups.add(popup);
   // Capture native form submission and links before any production callback.
   popup.addEventListener('submit', event => event.preventDefault(), true);
   popup.addEventListener('click', event => {
      const control = event.target.closest('button, input');
      if (event.target.closest('a') || (control && ['submit', 'image', 'reset'].includes(control.type))) {
         event.preventDefault();
      }
   }, true);
   popup.addEventListener('keydown', event => {
      if (event.key === 'Enter' && event.target.matches('input, select, textarea')) event.preventDefault();
   }, true);
}
